import { lazy } from 'react';
import CareApp from '../CareApp';
import AppRouterTemplate from './AppRouterTemplate';
import { getAppRoutesFromConfigs } from './GetAppRoutesFromConfigs';
import { adminDashboardRouteConfig } from './routes/AdminDashboardRoutes';
import { avonPatientRouteConfig } from './routes/AvonPatientRoutes';
import { callsPageRouteConfig } from './routes/CallsPageRoutes';
import { docketRouteConfig } from './routes/DocketRoutes';
import { enrollmentRouteConfig } from './routes/EnrollmentRoutes';
import { guideListPageRouteConfig } from './routes/GuideListRoutes';
import { hospitalizationRouteConfig } from './routes/HospitalizationRoutes';
import { loginPageRouteConfig } from './routes/LoginRoutes';
import { memberListRouteConfig } from './routes/MemberListRoutes';
import { memberPageRouteConfig } from './routes/MemberPageRoutes';
import { managerOperatingSystemRouteConfig } from './routes/ManagerOperatingSystemRoutes';
import { noAccessPageRouteConfig } from './routes/NoAccessRoutes';
import { trainingAdminPageRouteConfig } from './routes/TrainingAdminRoutes';
const ErrorPage = lazy(() =>
  import('./routes/StatusPages/ErrorPage').then(module => ({
    default: module.default,
  }))
);

export { getMemberPageUrl } from './navigationHooks.util';
export { useAppNavigation } from './useAppNavigation.util';

const childRoutes = getAppRoutesFromConfigs([
  docketRouteConfig,
  enrollmentRouteConfig,
  memberListRouteConfig,
  memberPageRouteConfig,
  callsPageRouteConfig,
  guideListPageRouteConfig,
  trainingAdminPageRouteConfig,
  loginPageRouteConfig,
  avonPatientRouteConfig,
  adminDashboardRouteConfig,
  managerOperatingSystemRouteConfig,
  hospitalizationRouteConfig,
  noAccessPageRouteConfig,
]);

export const routes = [
  {
    path: '/',
    element: <CareApp />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <AppRouterTemplate />,
        children: childRoutes,
        errorElement: <ErrorPage />,
      },
      {
        path: '*',
        element: <ErrorPage />,
      },
    ],
  },
];
